<template>
  <div class="header-wrap">
    <a href="/"><img class="logo" src="https://yikerenyang.oss-cn-beijing.aliyuncs.com/bh6w98kr87600o0n1ert.png"
        alt=""></a>
    <ul class="header-menu">
      <li :class="activeIndex == index ? 'activeMenu' : ''" v-for="(item, index) in menuList" :key="item.label"
        @click="toPage(item.url, index)" @mouseenter="mouseenter(item)" @mouseleave="mouseleave">
        {{ item.label }}
      </li>
    </ul>
    <!--    <div class="header-search">
      <el-input v-model="searchValue" placeholder="请输入搜索关键词"></el-input>
      <i class="el-icon-search"></i>
    </div>-->
    <div class="phoneNav" @click="drawer = !drawer">
      <img src="@/assets/phoneNav.png" alt="">
    </div>
    <transition name="el-zoom-in-bottom">
      <div class="intopbox" v-show="showPopover || drawer" @mouseenter="handlePopoverEnter"
        @mouseleave="handlePopoverLeave">
        <div>
          <!-- 解决方案 / 产品介绍 -->
          <div class="plan"
            v-if="currentMenu.id == '1868917501615124482' || currentMenu.id == '1868925126838730753' || currentMenu.id == '1868933306608152578' || currentMenu.id == '1868933413533544449'">
            <a :href="item.url" class="plan-item" v-for="(item, index) in currentMenu.children" :key="item.id">
              <img class="plan-item-img" :src="item.icon" alt="">
              <div class="plan-item-info">
                <div class="plan-item-info-title">{{ item.label }}</div>
                <!--                产品介绍不显示-->
                <div class="plan-item-info-desc">{{ item.subtitle }}</div>
              </div>
            </a>
          </div>
        </div>
        <div class="phoneMenuList">
          <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" background-color="#f8fbff" router
            @select="handleOpenMenu">
            <template v-for="(item, index) in menuList">
              <el-menu-item :index="item.url" v-if="!item.children || item.children.length == 0">
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
              <el-submenu :index="item.url" v-else>
                <template slot="title">
                  <span>{{ item.label }}</span>
                </template>
                <el-menu-item v-for="(childrens, i) in item.children" :key="childrens.url" :index="childrens.url">
                  {{
                    childrens.label
                  }}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import { getPageColumn, getPageContent } from '@/API/home'

export default {
  name: 'headerWrap',

  data() {
    return {
      drawer: false,
      showPopover: false,
      isPopoverHovered: false,
      hideTimeout: null,
      activeIndex: 0,
      searchValue: '',
      defaultActive: '',
      menuList: [
        /* {
           label: '网站首页',
           url: '/index',
           key: '/index'
         },
         {
           label: '解决方案',
           url: '/programme',
           key: '/programme',
           children: [
             {label: '畜动力标准化产品', url: '/introduce', key: '/introduce'}
           ]
         },
         {
           label: '产品介绍',
           url: '/product',
           key: '/product',
           children: [
             {label: '动物耳标系列', url: '/product-details-list?type=1', key: '/product-details-list?type=1',}
           ]
         },
         {
           label: '客户案例',
           url: '/case',
           key: '/case',
         },
         {
           label: '新闻资讯',
           url: '/news',
           key: '/news',
           children: [
             {label: '公司新闻', url: '/news?type=1', key: '/news?type=1',},
             {label: '行业新闻', url: '/news?type=2', key: '/news?type=2',}
           ]
         },
         {
           label: '关于我们',
           url: '/about',
           key: '/about',
         },*/
      ],
      currentMenu: {},
      plan: [], //解决方案
    };
  },

  mounted() {

    this.getDataGetPageColumn()
    // this.updateActiveIndex(this.$route.path);
  },
  watch: {
    $route(to) {
      this.updateActiveIndex(to.path);
    },
  },
  methods: {
    //跳转页面
    toPage(url, index) {
      this.activeIndex = index
      this.$router.push(url).catch(() => {
      })
    },
    //获取当前菜单索引
     findMenuIndex (menuList, path){
      for (let i = 0; i < menuList.length; i++) {
        const item = menuList[i];
        // 如果当前项是父级且有 children
        if (item.children && item.children.length > 0) {
            if(item.url.includes('product') && path.includes('product/product-details')){
              return i
            }
          // 查找子菜单是否匹配
          const childIndex = item.children.findIndex(child =>
            child.url === path || child.url.includes(path) || path.includes(child.url)
          );
          if (childIndex !== -1) {
            return i;
          }
          // 如果找到匹配的子菜单，返回父菜单的索引
          // if (childIndex !== -1) {
          //   return i;  // 返回父菜单的索引
          // }
        }

        // 如果当前项没有 children，直接匹配当前菜单项
        if (item.url === path || item.url.includes(path) || path.includes(item.url)) {
          return i;
        }
      }
      return -1;  // 如果没有找到匹配项，返回 -1
    },
    //页面属性更新当前激活菜单
    updateActiveIndex(path) {
      this.defaultActive = this.$route.fullPath
      const foundIndex= this.findMenuIndex(this.menuList, path)
      if (foundIndex !== -1) {
        this.activeIndex = foundIndex;
      }
    },
    //鼠标移入菜单导航
    mouseenter(record) {
      // console.log(record)
      //案例
      if (record.id == '1868933241252507650' || record.key == '/index') {
        return false;
      }
      this.currentMenu = record;
      this.showPopover = false
      this.isPopoverHovered = true
      this.$nextTick(() => {
        this.showPopover = true
      })


    },
    //鼠标移入菜单导航
    mouseleave() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout); // 清除之前的延迟
      }
      this.isPopoverHovered = false
      this.hideTimeout = setTimeout(() => {
        if (!this.isPopoverHovered) {
          this.showPopover = false; // 延迟隐藏Popover
        }
      }, 300)
    },
    // 鼠标移入Popover区域
    handlePopoverEnter() {
      this.isPopoverHovered = true;
    },
    // 鼠标离开Popover区域
    handlePopoverLeave() {
      this.isPopoverHovered = false;
      this.showPopover = false;
    },

    async loadGetPageContent(key) {
      const { data } = await getPageContent({
        key,
        pageNumber: 1,
        pageSize: 20
      })
      return data.records
    },

    getDataGetPageColumn() {
      getPageColumn({
        pageNumber: 1,
        pageSize: 999
      }).then(async res => {
        const menuList = []
        for (let i = 0; i < res.data.records.length; i++) {
          const item = res.data.records[i];
          if (item.id !== '1870011990441787394') {
            item.url = this.formatUrl(item);
            item.children = await this.resChildren(item);
            item.label = item.columnName;
            item.key = item.id;
            delete item.child
            menuList.push(item);
          }
        }


        menuList.unshift({
          label: '网站首页',
          url: '/index',
          key: '/index'
        })
        this.menuList = menuList
        this.updateActiveIndex(this.$route.fullPath);
      })
    },
    //分类路由路径
    formatUrl(record) {
      let url = ''
      switch (record.id) {
        case '1868917501615124482':
          url = '/programme';
          break;
        case '1868925126838730753':
          url = '/product?id=1868925126838730753';
          break;
        case '1868933241252507650':
          url = '/case';
          break;
        case '1868933306608152578':
          url = '/news?id=1868933306608152578';
          break;
        case '1868933413533544449':
          url = '/about?id=1869984055357935617';
          break;
      }
      return url;
    },
    //处理children
    async resChildren(record) {
      let children = []
      switch (record.id) {
        case '1868917501615124482':
          const _children = await this.loadGetPageContent(record.id)
          children = _children.map(item => {
            item.key = item.id;
            item.label = item.title;
            item.icon = item.cover ? item.cover.split(",")[0] : [];
            item.url = '/introduce?id=' + item.id;
            return item
          });
          break;
        case '1868925126838730753':
          children = record.child.map(item => {
            item.label = item.columnName;
            item.icon = item.columnIcon;
            item.subtitle = item.remark;
            item.url = '/product-details-list?id=' + item.id;
            return item;
          })
          break;
        case '1868933241252507650':
          break;
        case '1868933306608152578':
          children = record.child.map(item => {
            item.label = item.columnName;
            item.icon = item.columnIcon;
            item.subtitle = item.remark;
            item.url = '/news?id=' + item.id;
            return item;
          })
          break;
        case '1868933413533544449':
          const _children2 = await this.loadGetPageContent('1871387845827035137')
          // const partner = record.child.find(item => item.id == '1871031404586926082')
          // partner.label = partner.columnName;
          // partner.subtitle = partner.remark;
          // partner.icon = partner.columnIcon;
          // partner.url = '/about/partner?id=' + partner.id;

          children = _children2.map(item => {
            item.key = item.id;
            item.label = item.title;
            item.icon = item.cover ? item.cover.split(",")[0] : [];;
            item.url = '/about?id=' + item.id;
            return item
          });
          // if (partner) {
          //   children.push(partner)
          // }


          break;
        default:
          break;
      }
      return children
    },
    handleOpenMenu(index, indexPath) {
      this.drawer = false;
    }
  },
};
</script>

<style lang="scss" scoped>
$col: #14c187;

.header-wrap {
  height: 100px;
  width: 100%;
  padding: 0 200px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f8fbff;

  .logo {
    height: 50px;
  }

  .el-menu--horizontal {
    border-bottom: none;
  }

  .header-menu {
    padding: 0;
    margin: 0;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-left: 50px;
    font-size: 20px;

    .activeMenu::after {
      content: '';
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 15px;
      color: $col;
      border-bottom: 4px solid $col;
    }

    li {
      list-style: none;
      padding: 16px;
      font-weight: 500;
      margin-left: 2px;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      &:hover {
        color: $col;
      }

      a {
        color: inherit;
      }
    }
  }

  .header-search {
    position: absolute;
    right: 60px;
    display: flex;
    align-items: center;

    .el-icon-search {
      margin-left: 10px;
      font-size: 30px;
      cursor: pointer;
    }
  }

  .phoneNav {
    width: 25px;
    height: 25px;
    display: none;

    img {
      height: 100%;
      width: 100%;
    }
  }
}

.menu-item-popover {
  width: 700px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  .menu-item-popover-items {
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 4px;

    &:hover {
      background: #eee;
    }

    .el-image {
      width: 60px;
      height: 60px;
    }

    .content {
      min-width: 0;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;

      .title {
        width: 100%;
        font-size: 20px;
        color: $col;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
      }

      .desc {
        width: 100%;
        color: #ccc;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
      }
    }
  }

}

.intopbox {
  width: 60%;
  min-width: 1200px;
  background-color: #fff;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 30px 50px;
  box-sizing: border-box;
  height: fit-content;
  max-height: 500px;
  overflow-y: auto;
  z-index: 9999;
  border-radius: 4px;

  .phoneMenuList {
    display: none;
  }


  .plan {
    display: flex;
    flex-wrap: wrap;

    &-item {
      display: flex;
      align-items: center;
      width: 33%;
      padding: 10px 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      cursor: pointer;

      &:hover {
        background-color: #f2f2f2;
      }

      &-img {
        margin-right: 10px;
        width: 50px;
        height: 50px;
        object-fit: cover;
      }

      &-info {
        &-title {
          font-weight: bold;
          margin-bottom: 10px;
        }

        &-desc {
          width: 280px;
          overflow: hidden;
          font-size: 14px;
          color: #999;
          white-space: normal; /* 允许多行 */
          overflow: hidden; /* 隐藏溢出的内容 */
          text-overflow: ellipsis; /* 显示省略号 */
          display: -webkit-box; /* 使用WebKit的盒模型 */
          -webkit-line-clamp: 2; /* 设置行数 */
          -webkit-box-orient: vertical; /* 设置盒模型的方向为垂直 */

        }
      }
    }
  }
}

@media (max-width: 1260px) {
  .header-wrap {
    .header-search {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .header-wrap {
    padding: 0 10px;
    justify-content: space-between;

    .header-menu {
      display: none;
    }

    .phoneNav {
      display: block;
      width: 25px;
      height: 25px;
    }
  }

  .plan {
    display: none;
  }


  .intopbox {
    width: 100%;
    min-width: unset;
    left: 0;
    border-radius: 0;
    transform: translateX(0);
    background-color: #f8fbff;
    padding: 0;
    max-height: max-content;
    overflow-y: hidden;

    .phoneMenuList {
      display: block;
    }

    .el-menu-item {
      font-size: 16px;
      font-weight: 600;
    }

    .el-submenu {
      ::v-deep .el-submenu__title {
        font-size: 16px;
        font-weight: 600;
      }

      .el-menu-item {
        font-weight: 500;
      }
    }

  }
}
</style>
